'use client'

import Login from "member/components/Pc/Login/Login"

export default Login
